import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input,forwardRef } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../view-contact/view-contact';
import { HomePage } from '../../../home/home';
import { SdfFormService } from '../../../../app/services/sdf-form-service';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../app/services/env-data-service';
import {ADFFormService} from '../../../../pages/adf-page/services/adf-form.service';
import { AddressDetail } from '../primary-applicant/address-detail/address-detail';
declare var google;
@Component({
  selector: 'adf-realestateassets-form',
  templateUrl: 'real-estate-assets.html',
  providers: [EnvDataService]
})
export class RealEstateAssets {
  @Input() editdata: any;
  @Input() mortagesection:boolean = true;
  @Output() realEstateFormData_evtemit=new EventEmitter();
  @ViewChild(forwardRef(() => AddressDetail))
  private AddressDetails: AddressDetail;
  // @ViewChild(AddressDetail) AddressDetails: AddressDetail;
  public check_mortage=true;
  public check_loansplit=true;
  public new_mortage = [];
  public realindex = 0;
  public fixed_rate_limit=[];
  callMethod() {


  }

  public numberMask = createNumberMask({
    prefix: '$ ',
    allowDecimal: true,
    decimalSymbol : ".",
    decimalLimit : 2,
    suffix: ' '
  })

  realEstateForm : FormGroup;

  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  deleted_access: any;
  firstname1: any;
  public change_log_string: any;
  public allRealEstatess: any;
  public realEstate_details: any;
  public rand= new Date().getTime();
  public percentage_error:boolean = false;
  public address_details :any;

  public validation_messages = {
    'firstname': [
        { type: 'required', message: 'Firstname is required.' }
    ],
    'lastname': [
      { type: 'required', message: 'Lastname is required.' }
    ],
    'email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ],
    'date_of_birth': [
      { type: 'required', message: 'Date of Birth is required.' }
    ],
    'secondary_firstname': [
      { type: 'required', message: 'Firstname is required.' }
    ],
    'secondary_lastname': [
      { type: 'required', message: 'Lastname is required.' }
    ],
    'secondary_email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'secondary_mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ],
    'secondary_date_of_birth': [
      { type: 'required', message: 'Date of Birth is required.' }
    ],
    'primayr_goal_intention': [
      { type: 'required', message: 'Primary goal/intention of the applicant is required.' }
    ],
    'address_type': [
      { type: 'required', message: 'Address Type is required.' }
    ],
    'address_format': [
      { type: 'required', message: 'Address format is required.' }
    ],
    'street_number': [
      { type: 'required', message: 'Street Number is required.' }
    ],
    'street_name': [
      { type: 'required', message: 'Street Name is required.' }
    ],
    'street_type': [
      { type: 'required', message: 'Street Type is required.' }
    ],
    'city': [
      { type: 'required', message: 'City is required.' }
    ],
    'state': [
      { type: 'required', message: 'State is required.' }
    ],
    'postcode': [
      { type: 'required', message: 'Postcode is required.' }
    ],
    'country': [
      { type: 'required', message: 'Country is required.' }
    ],
    'housing_situation': [
      { type: 'required', message: 'Housing situation is required.' }
    ],
    'move_in_date': [
      { type: 'required', message: 'Move in date is required.' }
    ],
    'previous_address_type': [
      { type: 'required', message: 'Address Type is required.' }
    ],
    'previous_address_format': [
      { type: 'required', message: 'Address format is required.' }
    ],
    'previous_street_number': [
      { type: 'required', message: 'Street Number is required.' }
    ],
    'previous_street_name': [
      { type: 'required', message: 'Street Name is required.' }
    ],
    'previous_street_type': [
      { type: 'required', message: 'Street Type is required.' }
    ],
    'previous_city': [
      { type: 'required', message: 'City is required.' }
    ],
    'previous_state': [
      { type: 'required', message: 'State is required.' }
    ],
    'previous_postcode': [
      { type: 'required', message: 'Postcode is required.' }
    ],
    'previous_country': [
      { type: 'required', message: 'Country is required.' }
    ],
    'previous_housing_situation': [
      { type: 'required', message: 'Housing situation is required.' }
    ],
    'previous_move_in_date': [
      { type: 'required', message: 'Move in date is required.' }
    ],
    'previous_move_out_date': [
      { type: 'required', message: 'Move out date is required.' }
    ],
    'reference_broker': [
      { type: 'required', message: 'Broker is required.' }
    ],
    'gender': [
      { type: 'required', message: 'Gender is required.' }
    ],
    'current_marital_status': [
      { type: 'required', message: 'Merital status is required.' }
    ],
    'do_you_have_children': [
      { type: 'required', message: 'Do you have children?' }
    ],
    'how_many_children': [
      { type: 'required', message: 'Enter How many dependents do you have under the age of 18?' }
    ],
    'first_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'second_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'third_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'fourth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'fifth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'sixth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'employementType': [
      { type: 'required', message: 'Employment type required.' }
    ],
    'currentlyEmployment': [
      { type: 'required', message: 'Current employment required.' }
    ],
    'expectFindWork': [
      { type: 'required', message: 'Enter expect find work.' }
    ],
    'statusyourEmployment': [
      { type: 'required', message: 'Status your employment required.' }
    ],
    'your_occupation': [
      { type: 'required', message: 'Your occupation required.' }
    ],
    'start_date': [
      { type: 'required', message: 'When did you start in this role required.' }
    ],
    'business_name': [
      { type: 'required', message: 'Business name required.' }
    ],
    'nature_of_business': [
      { type: 'required', message: 'Nature of business required.' }
    ],
    'amount': [
      { type: 'required', message: 'This field is required.' }
    ],
    'frequency': [
      { type: 'required', message: 'This field is required.' }
    ],
    'date_commenced': [
      { type: 'required', message: 'This field is required.' }
    ],
    'percentage_asset': [
      { type: 'max', message: 'Must be less than 100.' },
      { type: 'min', message: 'Must be greater than 1.' },
      { type: 'required', message: 'This field is required.' }
    ],
    'asset_value': [
      { type: 'maxlength', message: 'Maximum length should be 30.' },
      { type: 'minlength', message: 'Must be greater than 1.' },
      { type: 'required', message: 'This field is required.' }
    ],
    'current_balance': [
      { type: 'maxlength', message: 'Maximum length should be 30.' },
      { type: 'minlength', message: 'Must be greater than 1.' },
      { type: 'required', message: 'This field is required.' }
    ],
    'limit': [
      { type: 'maxlength', message: 'Maximum length should be 30.' },
      { type: 'minlength', message: 'Must be greater than 1.' },
      { type: 'required', message: 'This field is required.' }
    ],
    'repayments': [
      { type: 'maxlength', message: 'Maximum length should be 30.' },
      { type: 'minlength', message: 'Must be greater than 1.' },
      { type: 'required', message: 'This field is required.' }
    ],
    'asset_type': [
      { type: 'required', message: 'Asset type is required.' }
    ],
    'value_basis': [
      { type: 'required', message: 'Value basis is required.' }
    ],
    'ownership_title_name': [
      { type: 'required', message: 'Ownership title name is required.' }
    ],
    'primary_percentage_asset': [
      { type: 'required', message: 'Ownership percentage is required.' }
    ],
    'secondary_percentage_asset': [
      { type: 'required', message: 'Ownership percentage is required.' }
    ],
    'notes': [
      { type: 'required', message: 'Notes is required.' }
    ],
    'gross_amount': [
      { type: 'required', message: 'Rental Income Per Week is required' }
    ],
    'creditor': [
      { type: 'required', message: 'Creditor is required.' }
    ],
    'available_redraw': [
      { type: 'required', message: 'Redraw Offset is required.' }
    ],
    'loan_type': [
      { type: 'required', message: 'Load type is required.' }
    ],
    'interest_rate': [
      { type: 'required', message: 'Interest rate is required.' },
      { type: 'min', message: 'Interest rate minimum value 1.' },
      { type: 'max', message: 'Interest rate maximum value 100.' }
    ],
    'interest_rate_term': [
      { type: 'required', message: 'Interest rate term is required.' }
    ]
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public alertCtrl: AlertController,
    public SdfFormService: SdfFormService,
    public ADFFormService:ADFFormService
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];

    this.realEstateForm = formBuilder.group({
      firstname: [''],
      lastname: [''],
      itemRowsRealEstates: formBuilder.array([]),
      itemRowsMortgageSplits: formBuilder.array([]),
      addAnotherApplicantItem: this.formBuilder.array([])
    });


  }
  ngOnInit() {
  }


  ngOnChanges() {

  }

  editgetSDFUser(SDF_form_document_id, uid) {
    if (this.userRole == "super_admin" && this.deleted_access == 1) {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).orderBy('created_date', 'asc')).valueChanges();
    } else {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
    }
  }


   get formArrRealEstates() {
    return this.realEstateForm.get('itemRowsRealEstates') as FormArray;
  }

  get formArrMortgageSplits(){
    return this.realEstateForm.get('itemRowsMortgageSplits') as FormArray;
  }



  changeLog(event, index: any) {

  }

  public changeOwnershipPercentage($event, index){


    this.realEstatePercentageDivision(index);

  }

  realEstatePercentageDivision(i){


    debugger;
    if(this.realEstateForm.controls['addAnotherApplicantItem']['controls'].length === 0){
      let percentage_assert:number=parseInt((<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[0].get('primary_percentage_asset').value);
      if(percentage_assert <= 100)
      {

        this.percentage_error = false;

        (<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[0].get('primary_percentage_asset').setErrors(null);

      }else
      {

        this.formArrRealEstates.controls[0].get('primary_percentage_asset').setErrors({});

        this.percentage_error = true;
      }
    }
    else
    {
      let percentage_realestate:any;
      let arr=[];
      percentage_realestate=parseInt((<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[i].get('primary_percentage_asset').value);

      (<FormArray>this.realEstateForm.controls.addAnotherApplicantItem).controls.forEach((element,index)=>{
             let data=(<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[i].get('secondary_percentage_asset_'+index).value;
             if(data != "")
             {
               arr.push(parseInt(data))
             }
      })

      arr.forEach(data=>{
        percentage_realestate=percentage_realestate + data;
      })

      if(percentage_realestate <= 100)
      {


        (<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[i].get('primary_percentage_asset').setErrors(null);
        (<FormArray>this.realEstateForm.controls.addAnotherApplicantItem).controls.forEach((element,index)=>{
         (<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[i].get('secondary_percentage_asset_'+index).setErrors(null);

        })
        this.percentage_error = false;
      }
      else
      {


         (<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[i].get('primary_percentage_asset').setErrors({});
        (<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[i].get('primary_percentage_asset').markAsUntouched();

        (<FormArray>this.realEstateForm.controls.addAnotherApplicantItem).controls.forEach((element,index)=>{
         (<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[i].get('secondary_percentage_asset_'+index).setErrors({});
         (<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[i].get('secondary_percentage_asset_'+index).markAsUntouched();

        })



        this.percentage_error = true;

      }
    }

  }

  public changeAddressFormat($event, index, types){

  }

  updateAddress(inputText, index, type){
    let addressInput = document.getElementById("address_"+this.rand+'_'+index);
    let autocomplete = new google.maps.places.Autocomplete(addressInput, {
      componentRestrictions: { country: 'AU' }
    });
    autocomplete.inputId = addressInput;
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        let address_format = this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.address_format.value;
        let full_address = this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.full_address.value.split(' ');
        let full_address1 = full_address[0].split('/');
        if(full_address1.length == 1){
          full_address1 = full_address[0].split('-');
        }
        for (let i=0; i < place.address_components.length; i++){
          if (place.address_components[i].types[0] == "street_number") {
            if(place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0){
              this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_number.setValue(place.address_components[i].long_name);
            }else if(full_address1.length > 1){
              if(address_format == 'nonStandard'){
                this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_number.setValue(full_address[0]);
                this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.unit_number.setValue(full_address1[0]);
              }else{
                this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_number.setValue(full_address[0]);
                this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.unit_number.setValue(full_address1[0]);
              }
            }else{
              this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_number.setValue(place.address_components[i].long_name);
            }
          }

          if (place.address_components[i].types[0] == "route") {
            let get_route = place.address_components[i].long_name;
            let type = place.address_components[i].long_name.split(" ");
            let typeName = type[type.length-1];
            let get_street_name = get_route.split(" "+typeName).join("");
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_name.setValue(get_street_name);
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_type.setValue(typeName.toUpperCase());

          }
          if (place.address_components[i].types[0] == "locality") {
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.city.setValue(place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "administrative_area_level_1") {
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.state.setValue(place.address_components[i].short_name);
          }
          if (place.address_components[i].types[0] == "country") {
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.country.setValue(place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "postal_code") {
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.postcode.setValue(place.address_components[i].long_name);
          }
        }

    });
  }

  collectLogData(event, type, index){
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'address_type'){
      this.old_val = (this.applicant_details.address_type == undefined) ? '' : this.applicant_details.address_type;
      property = 'Address Type';
    }
    if(type == 'street_type'){
      this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
      property = 'Street Type';
    }
    if(type == 'state'){
      this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
      property = 'State';
    }
    if(type == 'country'){
      this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
      property = 'Country';
    }
    if(type == 'housing_situation'){
      this.old_val = (this.applicant_details.housing_situation == undefined) ? '' : this.applicant_details.housing_situation;
      property = 'Housing Situation';
    }
    if(type == 'move_in_date'){
      this.old_val = (this.applicant_details.move_in_date == undefined) ? '' : this.applicant_details.move_in_date;
      property = 'Move in Date';
    }
    if(type == 'date_of_birth'){
      this.old_val = (this.applicant_details.date_of_birth == undefined) ? '' : this.applicant_details.date_of_birth;
      property = 'Date of Birth';
    }
    if(this.new_val != this.old_val){
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }

  }


  initItemRowsRealEstateSplit() {
    return this.formBuilder.group({
        creditor: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        available_redraw: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        mortgage_limit: [''],
        fixed_rate_limit:['',Validators.compose([Validators.maxLength(30), Validators.min(0), Validators.max(100)])],
        current_balance: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        loan_type: ['Interest Only Loan', Validators.compose([Validators.required, Validators.maxLength(30)])],
        repayments: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        interest_rate: ['', Validators.compose([Validators.required, Validators.maxLength(30), Validators.min(0), Validators.max(100)])],
        interest_rate_term: ['Fixed', Validators.compose([Validators.required, Validators.maxLength(30)])],
        document_id: [''],
        deleted: [0]
      });
  }

  initItemRowsMortgageSplit() {
    return this.formBuilder.group({
      creditor: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      available_redraw: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      current_balance: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      mortgage_limit: [''],
      fixed_rate_limit:['',Validators.compose([Validators.maxLength(30), Validators.min(0), Validators.max(100)])],
      loan_type: ['Interest Only Loan', Validators.compose([Validators.required, Validators.maxLength(30)])],
      repayments: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      interest_rate: ['', Validators.compose([Validators.required, Validators.maxLength(30), Validators.min(0), Validators.max(100)])],
      interest_rate_term: ['Fixed', Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0]
    });
  }

  initItemRowsRealEstatesLoad(data) {
    return this.formBuilder.group({

      asset_type: [data.asset_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: [data.asset_value, Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: ['Applicant Estimate', Validators.compose([Validators.maxLength(30)])],
      ownership_title_name: [data.ownership_title_name, Validators.compose([Validators.required, Validators.maxLength(200)])],
      primary_percentage_asset: [data.primary_percentage_asset, Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_0: [data.secondary_percentage_asset_0, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_1: [data.secondary_percentage_asset_1, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_2: [data.secondary_percentage_asset_2, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_3: [data.secondary_percentage_asset_3, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_4: [data.secondary_percentage_asset_4, Validators.compose([Validators.min(0), Validators.max(100)])],
      notes: [data.notes],
      address_format: [data.address_format, Validators.compose([Validators.required, Validators.maxLength(30)])],
      full_address: [''],
      floor_number: [data.floor_number, Validators.compose([Validators.maxLength(30)])],
      unit_number: [data.unit_number, Validators.compose([Validators.maxLength(30)])],
      building_name: [data.building_name, Validators.compose([Validators.maxLength(30)])],
      street_number: [data.street_number, Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_name: [data.street_name, Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_type: [data.street_type, Validators.compose([Validators.required, Validators.maxLength(30)])],
      city: [data.city, Validators.compose([Validators.required, Validators.maxLength(30)])],
      state: [data.state, Validators.compose([Validators.required, Validators.maxLength(30)])],
      postcode: [data.postcode, Validators.compose([Validators.required, Validators.maxLength(30)])],
      country: [data.country, Validators.compose([Validators.required, Validators.maxLength(30)])],
      gross_amount: [data.gross_amount, Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [data.document_id],
      deleted: [data.deleted],
      itemRowsMortgageSplits: this.formBuilder.array([this.initItemRowsRealEstateSplit()])
    });
  }

  initItemRowsRealEstate() {
    return this.formBuilder.group({

      asset_type: ['Real Estate', Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: ['Applicant Estimate', Validators.compose([Validators.maxLength(30)])],
      ownership_title_name: ['', Validators.compose([Validators.required, Validators.maxLength(200)])],
      primary_percentage_asset: ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_0: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_1: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_2: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_3: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_4: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      notes: [''],
      address_format: ['standard', Validators.compose([Validators.required, Validators.maxLength(30)])],
      full_address: [''],
      floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      building_name: ['', Validators.compose([Validators.maxLength(30)])],
      street_number: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_name: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_type: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      state: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      postcode: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      country: ['Australia', Validators.compose([Validators.required, Validators.maxLength(30)])],
      gross_amount: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0],
      itemRowsMortgageSplits: this.formBuilder.array([this.initItemRowsRealEstateSplit()])
    });
  }

  initItemRowsRealEstate_1(address_data) {
    return this.formBuilder.group({

      asset_type: ['Real Estate', Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: ['Applicant Estimate', Validators.compose([Validators.maxLength(30)])],
      ownership_title_name: ['', Validators.compose([Validators.required, Validators.maxLength(200)])],
      primary_percentage_asset: ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_0: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_1: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_2: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_3: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_4: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      notes: [''],
      address_format: [address_data.address_format, Validators.compose([Validators.required, Validators.maxLength(30)])],
      full_address: [''],
      floor_number: [address_data.floor_number, Validators.compose([Validators.maxLength(30)])],
      unit_number: [address_data.unit_number, Validators.compose([Validators.maxLength(30)])],
      building_name: [address_data.building_name, Validators.compose([Validators.maxLength(30)])],
      street_number: [address_data.street_number, Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_name: [address_data.street_name, Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_type: [address_data.street_type, Validators.compose([Validators.required, Validators.maxLength(30)])],
      city: [address_data.city, Validators.compose([Validators.required, Validators.maxLength(30)])],
      state: [address_data.state, Validators.compose([Validators.required, Validators.maxLength(30)])],
      postcode: [address_data.postcode, Validators.compose([Validators.required, Validators.maxLength(30)])],
      country: [address_data.country, Validators.compose([Validators.required, Validators.maxLength(30)])],
      gross_amount: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0],
      itemRowsMortgageSplits: this.formBuilder.array([this.initItemRowsRealEstateSplit()])
    });
  }

  initItemRowsRealEstate2(formObj) {
    debugger;
    return this.formBuilder.group({

      asset_type: [formObj.asset_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: [formObj.asset_value, Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: [formObj.value_basis, Validators.compose([Validators.maxLength(30)])],
      ownership_title_name: [formObj.ownership_title_name, Validators.compose([Validators.required, Validators.maxLength(200)])],
      primary_percentage_asset: [formObj.primary_percentage_asset, Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_0: [formObj.secondary_percentage_asset_0, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_1: [formObj.secondary_percentage_asset_1, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_2: [formObj.secondary_percentage_asset_2, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_3: [formObj.secondary_percentage_asset_3, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_4: [formObj.secondary_percentage_asset_4, Validators.compose([Validators.min(0), Validators.max(100)])],
      notes: [formObj.notes],
      address_format: [formObj.address_format, Validators.compose([Validators.required, Validators.maxLength(30)])],
      full_address: [formObj.full_address],
      floor_number: [formObj.floor_number, Validators.compose([Validators.maxLength(30)])],
      unit_number: [formObj.unit_number, Validators.compose([Validators.maxLength(30)])],
      building_name: [formObj.building_name, Validators.compose([Validators.maxLength(30)])],
      street_number: [formObj.street_number, Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_name: [formObj.street_name, Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_type: [formObj.street_type, Validators.compose([Validators.required, Validators.maxLength(30)])],
      city: [formObj.city, Validators.compose([Validators.required, Validators.maxLength(30)])],
      state: [formObj.state, Validators.compose([Validators.required, Validators.maxLength(30)])],
      postcode: [formObj.postcode, Validators.compose([Validators.required, Validators.maxLength(30)])],
      country: [formObj.country, Validators.compose([Validators.required, Validators.maxLength(30)])],
      gross_amount: [formObj.gross_amount, Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [formObj.document_id],
      deleted: [0],

      itemRowsMortgageSplits: this.formBuilder.array(this.addNestedFormGroup(formObj.split))
    });
  }
  addNestedFormGroup(mortgageplits){

    let arr1=[]
    mortgageplits.forEach(element=>{
      let z=this.formBuilder.group({
        creditor: [element.creditor, Validators.compose([Validators.required, Validators.maxLength(30)])],
        available_redraw: [element.available_redraw, Validators.compose([Validators.required, Validators.maxLength(30)])],
        mortgage_limit: [element.mortgage_limit],
        fixed_rate_limit:[element.fixed_rate_limit,Validators.compose([Validators.maxLength(30), Validators.min(0), Validators.max(100)])],
        current_balance: [element.current_balance, Validators.compose([Validators.required, Validators.maxLength(30)])],
        loan_type: [element.loan_type, Validators.compose([Validators.required, Validators.maxLength(30)])],
        repayments: [element.repayments, Validators.compose([Validators.required, Validators.maxLength(30)])],
        interest_rate: [element.interest_rate, Validators.compose([Validators.required, Validators.maxLength(30), Validators.min(0), Validators.max(100)])],
        interest_rate_term: [element.interest_rate_term, Validators.compose([Validators.required, Validators.maxLength(30)])],
        document_id: [element.document_id],
        deleted: [0]
      });
      arr1.push(z);
    })

    return arr1;
  }
  addRealEstates() {
    debugger;
   console.log(this.realEstateForm);
   console.log(this.address_details);
   console.log((<FormArray>this.realEstateForm.get('itemRowsRealEstates')));
   //this.realindex = 0;
    let realestatelenght = (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).length;
    if(realestatelenght > 0) {
      let index = 0;
        for (index = 0; index < realestatelenght; index++) {

          if(this.check_mortage) {
            if(this.new_mortage[index]) {

            }
            else {
            this.new_mortage[index]= true;
            }

            //this.realindex=1;
            //this.check_mortage = true;
          }
          else {
             this.new_mortage[index]= false;
          }
           if(index == 0) {
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('address_format').setValue(this.address_details.address_format);
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('floor_number').setValue(this.address_details.floor_number);
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('unit_number').setValue(this.address_details.unit_number);
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('building_name').setValue(this.address_details.building_name);
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('street_number').setValue(this.address_details.street_number);
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('street_name').setValue(this.address_details.street_name);
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('street_type').setValue(this.address_details.street_type);
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('city').setValue(this.address_details.city);
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('state').setValue(this.address_details.state);
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('postcode').setValue(this.address_details.postcode);
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('country').setValue(this.address_details.country);

            if((<FormArray>(<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('itemRowsMortgageSplits')).length == 0) {
              (<FormArray>(<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('itemRowsMortgageSplits')).push(this.initItemRowsRealEstateSplit());
            }

           }
           else {

           }
          this.realindex = this.realindex+1;

        }
        console.log(this.new_mortage);
        console.log(this.realEstateForm.get('itemRowsRealEstates'));
        console.log((<FormArray>this.realEstateForm.get('itemRowsRealEstates')));
      // while ((<FormArray>this.realEstateForm.get('itemRowsRealEstates')).length !== 0) {
      //   (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).removeAt(0);
      // }
      // this.realindex=0;
      // debugger;
      // //console.log(this.AddressDetail.addreDetail.value);
      // console.log(this.address_details); //AddressDetails
    }
    else {

      debugger
        if(this.address_details) {
          this.formArrRealEstates.push(this.initItemRowsRealEstate_1(this.address_details));
        }
        else {
          this.formArrRealEstates.push(this.initItemRowsRealEstate());

          (<FormArray>this.realEstateForm.controls['itemRowsRealEstates']).controls.forEach((ele1,i)=>{
            ele1.get('itemRowsMortgageSplits')['controls'].forEach((ele2,j)=>{
               console.log(ele2);
               //console.log(ele2.get('deleted').value);

              ele2.get('available_redraw').setValue(null);
              ele2.get('available_redraw').setErrors(null);


              ele2.get('creditor').setValue(null);
              ele2.get('creditor').setErrors(null);

              ele2.get('current_balance').setValue(null);
              ele2.get('current_balance').setErrors(null);


              ele2.get('deleted').setValue(0);
              ele2.get('deleted').setErrors(null);


              ele2.get('document_id').setValue(null);
              ele2.get('document_id').setErrors(null);


              ele2.get('interest_rate').setValue(null);
              ele2.get('interest_rate').setErrors(null);


              ele2.get('interest_rate_term').setValue('Fixed');
              ele2.get('interest_rate_term').setErrors(null);


              ele2.get('loan_type').setValue('Interest Only Loan');
              ele2.get('loan_type').setErrors(null);


              ele2.get('mortgage_limit').setValue(null);
              ele2.get('mortgage_limit').setErrors(null);


              ele2.get('repayments').setValue(null);
              ele2.get('repayments').setErrors(null);
              // console.log('validation all valid');
              //  console.log(ele2);
            })
          })

          // let address = this.AddressDetails.addreDetail.value;
          //   console.log(address);
        }

        if(this.check_mortage) {
          if(this.new_mortage[this.realindex]) {

          }
          else {
          this.new_mortage[this.realindex]= !this.new_mortage[this.realindex];
          }

        this.realindex=1;
        //this.check_mortage = true;
        }
        else {
        this.realindex=1;
        //this.check_mortage = false;
        }
    }


    // if(this.address_details) {

    //   if(this.address_details.housing_situation == "Own Home" || this.address_details.housing_situation == "Own Home with Mortgage") {

    //     this.formArrRealEstates.push(this.initItemRowsRealEstate_1(this.address_details));
    //     // if(this.address_details.housing_situation == "Own Home")
    //     // {
    //     //   // this.check_mortage=false;
    //     //   // this.check_loansplit=false;
    //     //   (<FormArray>this.realEstateForm.controls['itemRowsRealEstates']).controls.forEach((ele1,i)=>{
    //     //     ele1.get('itemRowsMortgageSplits')['controls'].forEach((ele2,j)=>{
    //     //       // console.log(ele2);
    //     //       // console.log(ele2.get('deleted').value);
    //     //       ele2.get('available_redraw').setErrors(null);
    //     //       ele2.get('creditor').setErrors(null);
    //     //       ele2.get('current_balance').setErrors(null);

    //     //       ele2.get('deleted').setErrors(null);
    //     //       ele2.get('document_id').setErrors(null);

    //     //       ele2.get('interest_rate').setErrors(null);
    //     //       ele2.get('interest_rate_term').setErrors(null);
    //     //       ele2.get('loan_type').setErrors(null);
    //     //       ele2.get('mortgage_limit').setErrors(null);
    //     //       ele2.get('repayments').setErrors(null);
    //     //       // console.log('validation all valid');
    //     //       //  console.log(ele2);
    //     //     })
    //     //   })
    //     // }
    //   }
    //   else {
    //     this.formArrRealEstates.push(this.initItemRowsRealEstate());
    //   }

    // }
    // else {
    //   this.formArrRealEstates.push(this.initItemRowsRealEstate());
    // }
  }

  demo(){
    console.log('demo1 or demo');
    console.log((<FormArray>this.realEstateForm.controls['itemRowsRealEstates']));
    debugger
    // if(this.address_details.housing_situation == "Own Home")
    // {
      this.check_mortage=false;
      this.check_loansplit=false;
      (<FormArray>this.realEstateForm.controls['itemRowsRealEstates']).controls.forEach((ele1,i)=>{
        ele1.get('itemRowsMortgageSplits')['controls'].forEach((ele2,j)=>{
           console.log(ele2);

          //  ele2.get('available_redraw').clearValidators();
          //  ele2.get('available_redraw').updateValueAndValidity();

          //  ele2.get('creditor').clearValidators();
          //  ele2.get('creditor').updateValueAndValidity();

          //  ele2.get('current_balance').clearValidators();
          //  ele2.get('current_balance').updateValueAndValidity();

          //  ele2.get('deleted').clearValidators();
          //  ele2.get('deleted').updateValueAndValidity();

          //  ele2.get('document_id').clearValidators();
          //  ele2.get('document_id').updateValueAndValidity();

          //  ele2.get('interest_rate').clearValidators();
          //  ele2.get('interest_rate').updateValueAndValidity();

          //  ele2.get('interest_rate_term').clearValidators();
          //  ele2.get('interest_rate_term').updateValueAndValidity();

          //  ele2.get('loan_type').clearValidators();
          //  ele2.get('loan_type').updateValueAndValidity();


          //  ele2.get('mortgage_limit').clearValidators();
          //  ele2.get('mortgage_limit').updateValueAndValidity();

          //  ele2.get('repayments').clearValidators();
          //  ele2.get('repayments').updateValueAndValidity();

           //console.log(ele2.get('deleted').value);

          ele2.get('available_redraw').setValue(null);
          ele2.get('available_redraw').setErrors(null);


          ele2.get('creditor').setValue(null);
          ele2.get('creditor').setErrors(null);

          ele2.get('current_balance').setValue(null);
          ele2.get('current_balance').setErrors(null);


          ele2.get('deleted').setValue(0);
          ele2.get('deleted').setErrors(null);


          ele2.get('document_id').setValue(null);
          ele2.get('document_id').setErrors(null);


          ele2.get('interest_rate').setValue(null);
          ele2.get('interest_rate').setErrors(null);


          ele2.get('interest_rate_term').setValue('Fixed');
          ele2.get('interest_rate_term').setErrors(null);


          ele2.get('loan_type').setValue('Interest Only Loan');
          ele2.get('loan_type').setErrors(null);


          ele2.get('mortgage_limit').setValue(null);
          ele2.get('mortgage_limit').setErrors(null);


          ele2.get('repayments').setValue(null);
          ele2.get('repayments').setErrors(null);

          // ele1.get('itemRowsMortgageSplits').updateValueAndValidity();
          // console.log('validation all valid');
          //  console.log(ele2);
        })
        // ele1.get('itemRowsMortgageSplits').setValue(null);
        // ele1.get('itemRowsMortgageSplits').setErrors(null);
        //
      })
    // }

    this.addRealEstates();
  }
  demo2(){
    console.log("demo2");
    debugger;
    this.check_mortage=true;
    this.check_loansplit=true;

    (<FormArray>this.realEstateForm.controls['itemRowsRealEstates']).controls.forEach((ele1,i)=>{
      ele1.get('itemRowsMortgageSplits')['controls'].forEach((ele2,j)=>{
        ele2.get('loan_type').setValue('Interest Only Loan');
        ele2.get('interest_rate_term').setValue('Fixed');
      })
    })
    this.addRealEstates();
  }

  addnewRealEstates() {

    //this.check_mortage=false;
    debugger;
    let realestatelenght = (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).length;
    this.realindex = realestatelenght;

    this.check_loansplit=true;

     if(this.mortagesection) {
      this.new_mortage[this.realindex]= true;
     }
     else {
        if(this.new_mortage[this.realindex]) {
        }
        else {
        this.new_mortage[this.realindex]= !this.new_mortage[this.realindex];
        }
     }


    debugger;
    this.formArrRealEstates.push(this.initItemRowsRealEstate());


  }

  addNewMortgageSplits(index) {

    this.formArrRealEstates.controls[index]['controls']['itemRowsMortgageSplits'].push(this.initItemRowsMortgageSplit());

  }

  deleteRestoreDocument(index: number, document_id: any, type: any, collection: any, status: any, index1: number) {
    let alert = this.alertCtrl.create({
      title: 'Confirm '+status+' '+type,
      message: 'Are you sure you want to '+status+' this '+type+' ?',
      buttons: [
          {
              text: 'No',
              handler: () => {

              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  let deleted = 0;
                  if(status == 'delete'){
                    deleted = 1;
                  }
                  let postData = {
                    'document_id' : document_id,
                    'collection': collection,
                    'deleted': deleted,
                    'deleted_date' : new Date().getTime()
                  }
                  this.SdfFormService.deleteDocument(postData);
                  if(status == 'delete'){
                    if(type == 'real estate'){
                      this.formArrRealEstates.removeAt(index);
                    }
                  }
                }else{
                  if(status == 'delete'){
                    if(type == 'real estate'){
                      this.formArrRealEstates.removeAt(index);
                    }
                  }
                }
                if(this.new_mortage[index]) {

                }
                else {
                  this.new_mortage[index]= !this.new_mortage[index];
                }

                this.realindex = this.realindex - 1
                //this.realindex = this.formArrRealEstates.length - 1
              }
          }
      ]
    });
    alert.present();
  }

  updateAndDeleteLoanSplit(parent_index: number, index: number, document_id: any, parent_document_id: any, status: any) {
    let alert = this.alertCtrl.create({
      title: 'Confirm delete Loan Split',
      message: 'Are you sure you want to delete this Loan Split?',
      buttons: [
          {
              text: 'No',
              handler: () => {

              }
          },
          {
              text: 'Yes',
              handler: () => {

                if(document_id !=""){
                  let deleted = 0;
                  if(status == 'delete'){
                    deleted = 1;
                  }
                  let postData = {
                    'document_id' : document_id,
                    'parent_document_id' : parent_document_id,
                    'collection': 'SDF_realestate',
                    'deleted': deleted,
                    'parent_index': parent_index,
                    'index': index,
                    'deleted_date' : new Date().getTime()
                  }
                  this.SdfFormService.deleteDocument(postData);
                  if(status == 'delete'){
                    if(this.userRole == "super_admin" && this.deleted_access == 1){
                      this.formArrRealEstates.controls[parent_index]['controls'].itemRowsMortgageSplits.value[index].deleted = 1;
                      this.formArrRealEstates.push(this.initItemRowsRealEstatesLoad(this.formArrRealEstates.controls[parent_index]['controls'].itemRowsMortgageSplits));
                    }
                    this.formArrRealEstates.controls[parent_index]['controls'].itemRowsMortgageSplits.removeAt(index);
                  }else{

                  }
                }else{
                  if(status == 'delete'){
                    this.formArrRealEstates.controls[parent_index]['controls'].itemRowsMortgageSplits.removeAt(index);
                  }
                }
              }
          }
      ]
    });
    alert.present();
  }

  codeInput(event) {
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.updateValueAndValidity();
      control.markAsDirty();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  getValue(){
    // this.markFormGroupTouched(this.realEstateForm);
    this.realEstateForm.updateValueAndValidity();
    this.realEstateFormData_evtemit.emit({realEstateFormData:this.realEstateForm.value, formStatus:true,realestateform:this.realEstateForm});
  }

    populateDataForEdit(data,addressData){
    debugger;
    //this.realindex = 0;
    // console.log(data);
    if(data.length > 0)
    {

      data.forEach((element,index)=>{

        console.log(element);
        // if(this.new_mortage[index]) {
        // }
        // else {
        //  this.new_mortage[index]= !this.new_mortage[index];
        // }

        //let newElement=element;
        //let splits = [];
         if(!element.split) {
            if(element.itemRowsMortgageSplits) {
                element.itemRowsMortgageSplits.forEach(splitelement => {
                  if(splitelement.creditor) {
                    //splits.push(splitelement);
                    this.new_mortage[index] = true;
                  }
                  else {
                  this.new_mortage[index] = false;
                  }

              });
              element.split=element.itemRowsMortgageSplits;
            }
            else {
              element.split = [];
              //this.new_mortage[index] = false;
            }

         }
         else {
              element.split.forEach(splitelement => {
                if(splitelement.creditor) {
                  //splits.push(splitelement);
                  this.new_mortage[index] = true;
                }
                else {
                this.new_mortage[index] = false;
                }

            });

         }
         console.log('split',element.split)
         if(element.split.length == 0) {
           this.new_mortage[index] =false;
         }
        //newElement.split = splits;
         //console.log(element.itemRowsMortgageSplits);
        //delete newElement.itemRowsMortgageSplits;

        let z=this.initItemRowsRealEstate2(element);

        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).push(z);

        this.realindex = this.realindex + 1;

      })

      debugger;
      console.log(addressData);
      console.log(this.realEstateForm);
      for(var i=0;i<addressData.length;i++){
        if(addressData[i].type == 'primary')
        {
          let data = addressData[i].contact_details.address;
          for(var j=0;j<data.length;j++)
          {
            if (data[j].type == 'current') {

              (<FormArray>this.realEstateForm.controls['itemRowsRealEstates']).controls.forEach((ele1,i)=>{
                ele1.get('itemRowsMortgageSplits')['controls'].forEach((ele2,j)=>{
                  console.log('initial',ele2);
                  // console.log(ele2.get('deleted').value);
                  //ele2.get('available_redraw').setValue(null);
                  ele2.get('available_redraw').setErrors(null);

                  //ele2.get('creditor').setValue(null);
                  ele2.get('creditor').setErrors(null);

                  //ele2.get('current_balance').setValue(null);
                  ele2.get('current_balance').setErrors(null);

                  //ele2.get('deleted').setValue(0);
                  ele2.get('deleted').setErrors(null);

                  //ele2.get('document_id').setValue(null);
                  ele2.get('document_id').setErrors(null);

                  //ele2.get('interest_rate').setValue(null);
                  ele2.get('interest_rate').setErrors(null);

                  //ele2.get('interest_rate_term').setValue(null);
                  ele2.get('interest_rate_term').setErrors(null);

                  //ele2.get('loan_type').setValue(null);
                  ele2.get('loan_type').setErrors(null);

                  //ele2.get('mortgage_limit').setValue(null);
                  ele2.get('mortgage_limit').setErrors(null);

                  //ele2.get('repayments').setValue(null);
                  ele2.get('repayments').setErrors(null);

                  console.log('validation all valid');
                   console.log('final',ele2);
                })
              })


              // if(data[j].housing_situation == 'Own Home')
              // {
              //   // this.check_mortage=false;
              //   // this.check_loansplit=false;



              // }
              this.address_details = data[j];
              //this.formArrRealEstates.push(this.initItemRowsRealEstate_1(data[j]));
            }
          }
        }
      }

    }
    else
    {

    }
    }
    setAddressDataForEdit(newrealestate,data) {
      console.log(newrealestate);
      console.log(data);
      let thiss = this;
      //this.formArrRealEstates.push(this.initItemRowsRealEstate());
       if(newrealestate) {
         if(newrealestate.length == 0) {
          //this.addnewRealEstates();
         }
       }
       else {
       // this.addnewRealEstates();
       }

      debugger;
      data.forEach(contactelement => {
        if(contactelement.type == 'primary')
        {
          let data = contactelement.contact_details.address;
          for(var j=0;j<data.length;j++)
          {
            if (data[j].type == 'current') {

              this.address_details = data[j];
              if(this.address_details.housing_situation == 'Own Home'
                || this.address_details.housing_situation == 'Own Home with Mortgage')
                {
                  thiss.addnewRealEstates();
                  console.log(this.address_details);
                }


              (<FormArray>this.realEstateForm.controls['itemRowsRealEstates']).controls.forEach((ele1,i)=>{
                ele1.get('itemRowsMortgageSplits')['controls'].forEach((ele2,j)=>{
                  console.log('initial',ele2);
                  // console.log(ele2.get('deleted').value);
                  //ele2.get('available_redraw').setValue(null);
                  ele2.get('available_redraw').setErrors(null);

                  //ele2.get('creditor').setValue(null);
                  ele2.get('creditor').setErrors(null);

                  //ele2.get('current_balance').setValue(null);
                  ele2.get('current_balance').setErrors(null);

                  //ele2.get('deleted').setValue(0);
                  ele2.get('deleted').setErrors(null);

                  //ele2.get('document_id').setValue(null);
                  ele2.get('document_id').setErrors(null);

                  //ele2.get('interest_rate').setValue(null);
                  ele2.get('interest_rate').setErrors(null);

                  //ele2.get('interest_rate_term').setValue(null);
                  ele2.get('interest_rate_term').setErrors(null);

                  //ele2.get('loan_type').setValue(null);
                  ele2.get('loan_type').setErrors(null);

                  //ele2.get('mortgage_limit').setValue(null);
                  ele2.get('mortgage_limit').setErrors(null);

                  //ele2.get('repayments').setValue(null);
                  ele2.get('repayments').setErrors(null);

                  console.log('validation all valid');
                   console.log('final',ele2);

                })
              })




            }
          }
        }
      });
      console.log(<FormArray>this.realEstateForm.get('itemRowsRealEstates'));
      (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('address_format').setValue(this.address_details.address_format);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('floor_number').setValue(this.address_details.floor_number);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('unit_number').setValue(this.address_details.unit_number);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('building_name').setValue(this.address_details.building_name);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('street_number').setValue(this.address_details.street_number);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('street_name').setValue(this.address_details.street_name);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('street_type').setValue(this.address_details.street_type);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('city').setValue(this.address_details.city);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('state').setValue(this.address_details.state);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('postcode').setValue(this.address_details.postcode);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('country').setValue(this.address_details.country);
    }

  setrealEstateForm(primaryformget,addressformvalue) {

    debugger;
    this.address_details = addressformvalue;
    if(primaryformget) {

      this.realEstateForm.controls.firstname.setValue(primaryformget.firstname);
      this.realEstateForm.controls.lastname.setValue(primaryformget.lastname);
      primaryformget.addAnotherApplicantItem.forEach((item,index) => {

        if(this.formApplicant.value[index]) {
          this.formApplicant.value[index].secondary_firstname = item.secondary_firstname;
          this.formApplicant.value[index].secondary_lastname = item.secondary_lastname;
          }
          else {
            this.formApplicant.push(this.initaddAnotherApplicant(item));
          }

      });

    }
  }
  getUserData(e) {

    debugger;
    let realestatelenght = (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).length;
    for (let index = 0; index <= realestatelenght; index++) {
      if(this.new_mortage[index]) {
        this.new_mortage[index]= !this.new_mortage[index];
      }


    }
    while ((<FormArray>this.realEstateForm.get('itemRowsRealEstates')).length !== 0) {
      (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).removeAt(0);
    }

    let address = [];
    if(e.contact_details.address) {
      e.contact_details.address.forEach(element => {
        if (element.type === "current") {

          if(element.address_format == '') {
            element.address_format = 'standard';
          }


          if(element.address_type == '') {
            //console.lo
            element.address_type = 'Home';
          }

          if(element.housing_situation == '') {
            element.housing_situation = 'Boarding';
          }
          address.push(element);

          if(element.housing_situation == 'Own Home') {
            this.formArrRealEstates.push(this.initItemRowsRealEstate_1(element));

            (<FormArray>this.realEstateForm.controls['itemRowsRealEstates']).controls.forEach((ele1,i)=>{
              ele1.get('itemRowsMortgageSplits')['controls'].forEach((ele2,j)=>{
                 console.log(ele2);

                 ele2.get('available_redraw').clearValidators();
                 ele2.get('available_redraw').updateValueAndValidity();

                 ele2.get('creditor').clearValidators();
                 ele2.get('creditor').updateValueAndValidity();

                 ele2.get('current_balance').clearValidators();
                 ele2.get('current_balance').updateValueAndValidity();

                 ele2.get('deleted').clearValidators();
                 ele2.get('deleted').updateValueAndValidity();

                 ele2.get('document_id').clearValidators();
                 ele2.get('document_id').updateValueAndValidity();

                 ele2.get('interest_rate').clearValidators();
                 ele2.get('interest_rate').updateValueAndValidity();

                 ele2.get('interest_rate_term').clearValidators();
                 ele2.get('interest_rate_term').updateValueAndValidity();

                 ele2.get('loan_type').clearValidators();
                 ele2.get('loan_type').updateValueAndValidity();


                 ele2.get('mortgage_limit').clearValidators();
                 ele2.get('mortgage_limit').updateValueAndValidity();

                 ele2.get('repayments').clearValidators();
                 ele2.get('repayments').updateValueAndValidity();

                 //console.log(ele2.get('deleted').value);



              })

              //
            })

            //this.new_mortage[this.realindex]= !this.new_mortage[this.realindex];
            this.realindex=1;
            this.check_mortage = true;
          }
          else {
            this.formArrRealEstates.push(this.initItemRowsRealEstate_1(element));
              if(this.new_mortage[this.realindex]) {
              }
              else {
              this.new_mortage[this.realindex]= !this.new_mortage[this.realindex];
              }

              this.realindex=1;
            this.check_mortage = false;
          }

        }
      });
    }

    this.address_details = address[0];
  }
  get formApplicant() {
    return this.realEstateForm.get('addAnotherApplicantItem') as FormArray;
  }

  addAnotherApplicant() {

  }

  initaddAnotherApplicant(item) {
    return this.formBuilder.group({

      secondary_firstname: [item.secondary_firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [item.secondary_middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [item.secondary_lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [item.secondary_email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [item.secondary_mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [item.secondary_date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: [item.relationship_to_primary_applicant, Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }
  initaddAnotherApplicant_one(item) {
    return this.formBuilder.group({

      secondary_firstname: [item.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [item.middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [item.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [item.email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [item.mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [item.date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30)])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }

  setaddressvalue(addressobj) {
    debugger;
    console.log(addressobj);
    console.log(this.realEstateForm);
    if(this.address_details){
      console.log('yes')
    }
    else {
      if((<FormArray>this.realEstateForm.get('itemRowsRealEstates')).length > 0) {
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('address_format').setValue(addressobj.address_format);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('floor_number').setValue(addressobj.floor_number);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('unit_number').setValue(addressobj.unit_number);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('building_name').setValue(addressobj.building_name);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('street_number').setValue(addressobj.street_number);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('street_name').setValue(addressobj.street_name);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('street_type').setValue(addressobj.street_type);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('city').setValue(addressobj.city);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('state').setValue(addressobj.state);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('postcode').setValue(addressobj.postcode);
        (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('country').setValue(addressobj.country);
        if(addressobj.housing_situation == "Own Home") {
          // (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).at(0).get('itemRowsMortgageSplits').setErrors(null)
          while ((<FormArray>this.realEstateForm.get('itemRowsRealEstates')).length !== 0) {
            (<FormArray>this.realEstateForm.get('itemRowsRealEstates')).removeAt(0);
          }

        }
      }

    }

  }

  setAdditionalDetails(data){
    console.log(data);
     data.forEach((element,index) => {
         if(element.type == "additional") {
           if(this.formApplicant.value[index]) {
             this.formApplicant.value[index].secondary_firstname = element.user_data.firstname;
             this.formApplicant.value[index].secondary_lastname = element.user_data.lastname;
             }
             else {
               this.formApplicant.push(this.initaddAnotherApplicant_one(element.user_data));
             }
         }
         else {
           this.realEstateForm.controls.firstname.setValue(element.user_data.firstname);
           this.realEstateForm.controls.lastname.setValue(element.user_data.lastname);
         }

     });
     console.log(this.realEstateForm);
   }

   showhidefixed(event,itemRowsMortgageSplits) {
     debugger;
     console.log(itemRowsMortgageSplits);
   }

   changeMortageStatus(event,index) {
     debugger;
     console.log(this.mortagesection);
     //this.mortagesection =event;
     this.new_mortage[index] = event
     if(!event) {
       let formlength = (<FormArray>(<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[index].get('itemRowsMortgageSplits')).length;
        // for (let arrindex = 0; index < formlength; arrindex++) {
        //   this.new_mortage[arrindex] = false;

        // }
        while ((<FormArray>(<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[index].get('itemRowsMortgageSplits')).length !== 0) {
          (<FormArray>(<FormArray>this.realEstateForm.controls.itemRowsRealEstates).controls[index].get('itemRowsMortgageSplits')).removeAt(0);
          //this.new_mortage[index] = false;
        }
     }
   }

}




// WEBPACK FOOTER //
// ./src/pages/adf-page/component/real-estate-assets/real-estate-assets.ts